import {FeatureFlagEnum, ModuleEnum} from 'src/api/ProactApiClient';
import {JHACustomOperations} from './customOperations';
import useActiveFeatureFlags from 'src/shared/hooks/useActiveFeatureFlags';
import {useModulePermissions} from './useModulePermissions';

/**
 * Hook for Job Hazard Analysis module permissions.
 * Combines module permissions with JHA feature flag check.
 * Includes standard operations plus JHA-specific transition operations.
 */
export function useJHAPermissions() {
  const flags = useActiveFeatureFlags();
  const hasJHAFlag = flags.includes(FeatureFlagEnum.JobHazardAnalysis);
  const perms = useModulePermissions(ModuleEnum.JobHazardAnalysises, JHACustomOperations);

  return {
    ...perms,
    // Gate all permissions behind the feature flag
    view: perms.view && hasJHAFlag,
    create: perms.create && hasJHAFlag,
    update: perms.update && hasJHAFlag,
    delete: perms.delete && hasJHAFlag,
    transitionPublish: perms.transitionPublish && hasJHAFlag,
    transitionManagerApprove: perms.transitionManagerApprove && hasJHAFlag,
    transitionSafetyApprove: perms.transitionSafetyApprove && hasJHAFlag,
    transitionUnapprove: perms.transitionUnapprove && hasJHAFlag,
  };
}
